import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class OrderRecipientFirstNameEmptyError extends Violation {
	public constructor() {
		super(ViolationSeverity.Error, 'data-model.orders.recipient.validation.first-name.required');
	}
}
